// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseAdminFactory instead of class inheritance

import { createBaseAdmin, type IBaseAdmin } from "../BaseAdminFactory";
import type { OfficeRole } from "le-coffre-resources/dist/Admin";
import type { QueryPayload } from "../../../types";
import type { IGetRolesParams, IPutRoleParams, IPostRoleParams } from "./OfficeRoles";
import {
	createGetMethod,
	createGetByUidMethod,
	createPutMethod,
	createPostMethod,
	createDeleteMethod,
} from "./helpers/officeRolesMethodsHelpers";

interface OfficeRolesInstance {
	get(q?: IGetRolesParams): Promise<OfficeRole[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<OfficeRole>;
	put(uid: string, body: IPutRoleParams): Promise<OfficeRole>;
	post(body: IPostRoleParams): Promise<OfficeRole>;
	delete(uid: string): Promise<OfficeRole>;
}

// Module-level singleton instance
let instance: OfficeRolesInstance | null = null;
let baseAdminInstance: IBaseAdmin | null = null;

function createOfficeRoles(): OfficeRolesInstance {
	if (!baseAdminInstance) {
		baseAdminInstance = createBaseAdmin();
	}

	const baseAdmin = baseAdminInstance;
	const baseUrl = baseAdmin.namespaceUrl.concat("/office-roles");

	return {
		get: createGetMethod(baseAdmin, baseUrl),
		getByUid: createGetByUidMethod(baseAdmin, baseUrl),
		put: createPutMethod(baseAdmin, baseUrl),
		post: createPostMethod(baseAdmin, baseUrl),
		delete: createDeleteMethod(baseAdmin, baseUrl),
	};
}

export function getOfficeRolesInstance(): OfficeRolesInstance {
	if (!instance) {
		instance = createOfficeRoles();
	}
	return instance;
}
